import { useCallback, useState } from "react";
import { readSeenRunErrorIds, rememberSeenRunErrorId } from "./run-error-storage";

export function useRunErrorDismissal() {
  const [dismissedRunErrorIds, setDismissedRunErrorIds] =
    useState<ReadonlySet<string>>(readSeenRunErrorIds);
  const dismissRunError = useCallback((runId: string) => {
    rememberSeenRunErrorId(runId);
    setDismissedRunErrorIds((current) => new Set(current).add(runId));
  }, []);
  return { dismissedRunErrorIds, dismissRunError };
}
